(() => {
  'use strict';
  function init(root = document) {
    const toggle = root.querySelector('.mobile-toggle');
    if (toggle && !toggle.dataset.bound) {
      toggle.dataset.bound = 'true';
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (menu) {
        const close = () => { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', 'Open menu'); };
        toggle.addEventListener('click', () => {
          const opening = toggle.getAttribute('aria-expanded') !== 'true';
          menu.hidden = !opening;
          toggle.setAttribute('aria-expanded', String(opening));
          toggle.setAttribute('aria-label', opening ? 'Close menu' : 'Open menu');
        });
        menu.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); toggle.focus(); } });
        menu.addEventListener('click', (event) => { if (event.target.closest('a')) close(); });
      }
    }
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.bound) return;
      section.dataset.bound = 'true';
      const panels = Array.from(section.querySelectorAll('[data-media-id]'));
      const thumbs = Array.from(section.querySelectorAll('[data-media-target]'));
      const showMedia = id => {
        if (!id || !panels.some(panel => panel.dataset.mediaId === String(id))) return;
        panels.forEach(panel => { panel.hidden = panel.dataset.mediaId !== String(id); if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause()); });
        thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.mediaTarget === String(id))));
      };
      thumbs.forEach(thumb => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget)));
      const select = section.querySelector('[data-variant-select]');
      if (select) {
        const update = (changeURL) => {
          const option = select.options[select.selectedIndex];
          const available = option.dataset.available === 'true' || option.dataset.inventoryPolicy === 'continue';
          const button = section.querySelector('[data-add-button]');
          button.disabled = false; button.textContent = 'Add to basket';
          section.querySelector('[data-product-price]').textContent = option.dataset.price;
          const compare = section.querySelector('[data-compare-price]');
          compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;
          const quantity = section.querySelector('[name="quantity"]');
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
          showMedia(option.dataset.media);
          if (changeURL) { const url = new URL(window.location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
        };
        select.addEventListener('change', () => update(true));
        update(false);
      }
      const productForm = section.querySelector('[data-product-form]');
      if (productForm && !productForm.dataset.ajaxBound) {
        productForm.dataset.ajaxBound = 'true';
        productForm.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = productForm.querySelector('[data-add-button]');
          const errorBox = productForm.querySelector('[data-cart-error]');
          const formData = new FormData(productForm);
          if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
          if (button) { button.disabled = true; button.textContent = 'Adding…'; }
          try {
            const response = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
              const message = data.description || data.message || data.status || ('Cart error ' + response.status);
              if (errorBox) { errorBox.textContent = String(message); errorBox.hidden = false; }
              if (button) { button.disabled = false; button.textContent = 'Add to basket'; }
              return;
            }
            window.location.href = window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart' : '/cart';
          } catch (error) {
            if (errorBox) { errorBox.textContent = 'Could not add this product to the basket. ' + error.message; errorBox.hidden = false; }
            if (button) { button.disabled = false; button.textContent = 'Add to basket'; }
          }
        });
      }
      const personalToggle = section.querySelector('[data-personalise-toggle]');
      if (personalToggle) {
        const group = section.querySelector('.personalisation-inputs');
        const name = section.querySelector('[data-personalise-name]');
        const updatePersonalisation = () => {
          group.hidden = !personalToggle.checked;
          group.querySelectorAll('input,textarea').forEach(input => { input.disabled = !personalToggle.checked; });
          name.required = personalToggle.checked;
        };
        personalToggle.addEventListener('change', updatePersonalisation);
        updatePersonalisation();
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.nav-dropdown[open]').forEach(details => { details.open = false; }); });
  document.addEventListener('click', event => { document.querySelectorAll('.nav-dropdown[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; }); });
})();

(() => { document.querySelectorAll('[data-country-select]').forEach(country => { const province = document.getElementById(country.dataset.provinceId); if (!province) return; const options = Array.from(country.options); const chosen = options.find(option => option.value === country.dataset.default || option.textContent === country.dataset.default); if (chosen) country.value = chosen.value; const update = () => { const selected = country.options[country.selectedIndex]; let provinces = []; try { provinces = JSON.parse(selected?.dataset.provinces || '[]'); } catch {} province.replaceChildren(); provinces.forEach(([value, label]) => { const option = new Option(label, value); option.selected = province.dataset.default === value || province.dataset.default === label; province.add(option); }); province.closest('[data-province-wrapper]').hidden = provinces.length === 0; province.disabled = provinces.length === 0; }; country.addEventListener('change', update); update(); }); })();
